export class Url {
    protocol: string;
    domain:string;
    port:string;
}
export const serve = (def: Url): string => {
    if (localStorage.add) {
        const patten = /(http|https)\:\/\/([\w\W]*[^\/])\/?/;
        return `${def.protocol}://${patten.exec(localStorage.add)[2].trim()}/`;
    } else {
        return `${def.protocol}://${def.domain}${def.port ? ':' : ''}${def.port}/`;
    }
};
export const delNilField = (value) => {
    for ( const i in value) {
        if ( value.hasOwnProperty(i)) {
            if (!(value[i] || value[i] === 0)) {
                delete value[i];
            }
            if (Array.isArray(value[i])) {
                if (value[i].lenght === 0) {
                    delete value[i];
                }
            }
        }
    }
    return value;
};
